import PropTypes from "prop-types";
import dayjs from "dayjs";

import PersonPresenter from "presenters/PersonPresenter";
import { capitalize } from "utils/stringUtils";
import FaceShape from "components/FaceShape";
import PlusShape from "components/PlusShape";

import Icon from "./components/Icon";
import { Root, PersonBackground, PersonHead, PersonInfo, PersonDateType, PersonDate, Cta } from "./styles";

const displayPersonDefaultPropOnClick = () => {};

const DisplayPerson = ({
  isCTA = false,
  person,
  onClick = displayPersonDefaultPropOnClick,
  dateType,
  dateToCelebrate,
  isDateTypeDisplay,
}) => {
  const dateTypeTrimmed = dateType ? dateType.replace("'", "").replace(" ", "") : "";
  const asset = PersonPresenter.defaultHeadAsset(person) || "";
  const date = dayjs(dateToCelebrate).format("MMM D");

  const handleClick = () => {
    if (isCTA) {
      onClick(person);
    } else {
      onClick({
        person,
        dateType,
        dateToCelebrate,
      });
    }
  };

  const renderPerson = () => {
    return (
      <>
        <PersonBackground dateTypeTrimmed={dateTypeTrimmed}>
          <Icon occasion={dateType} />
          <PersonHead src={asset} alt="Person" />
        </PersonBackground>
        <PersonInfo>
          {isDateTypeDisplay && (
            <>
              <PersonDateType component="span" align="center" variant="caption">
                {capitalize(dateType)}
              </PersonDateType>
              <PersonDate component="span" align="center" variant="caption">
                {date || "-"}
              </PersonDate>
            </>
          )}
        </PersonInfo>
      </>
    );
  };

  const renderCTA = () => {
    return (
      <>
        <Cta>
          <FaceShape color="#D8F0FB" />
          <PlusShape />
        </Cta>
        <PersonInfo>
          {isDateTypeDisplay && (
            <PersonDateType component="span" align="center" variant="caption">
              Add birthday
            </PersonDateType>
          )}
        </PersonInfo>
      </>
    );
  };

  return (
    <Root onClick={handleClick} role="presentation">
      {isCTA ? renderCTA() : renderPerson()}
    </Root>
  );
};

DisplayPerson.propTypes = {
  isCTA: PropTypes.bool,
  onClick: PropTypes.func,
  person: PersonPresenter.shape(),
  dateType: PropTypes.string,
  dateToCelebrate: PropTypes.string,
  isDateTypeDisplay: PropTypes.bool,
};

export default DisplayPerson;
